module.exports = __webpack_public_path__ + "static/img/user.34c8e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.png
// module id = 1111
// module chunks = 1